module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_0.7fbac6c2.png";